import cn from "classnames";
import React, { useCallback, useState } from "react";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";
import { CANVA_COMING_SOON } from "../../../../cores/canva/config";
import { fetchCanvaConnection } from "../../../../cores/canva/connectApi";
import { urlToDataURL } from "../../../../cores/utils";
import { TooltipWembii } from "../../TooltipWembii";
import { CanvaDesignPickerModal } from "../modals/CanvaDesignPickerModal";

type Props = {
  onPublish: (file: any, picture: string) => void;
  disabled?: boolean;
};

export const CanvaButton = ({ onPublish, disabled }: Props) => {
  const intl = useIntl();
  const [showPicker, setShowPicker] = useState(false);

  const handleExported = useCallback(
    async ({ exportUrl, designTitle }: { exportUrl: string; designTitle: string }) => {
      const file: any = {
        name: designTitle,
        lastModified: new Date().getTime(),
      };
      const picture: string = await urlToDataURL(exportUrl);
      onPublish(file, picture);
    },
    [onPublish]
  );

  const onCanvaButtonClicked = useCallback(async () => {
    if (disabled || CANVA_COMING_SOON) return;
    try {
      const c = await fetchCanvaConnection();
      if (c.connected) {
        setShowPicker(true);
      } else if (c.oauthUrl) {
        window.location.href = c.oauthUrl;
      } else {
        toast.error(intl.formatMessage({ id: "app.canvaConnect.oauthUrlMissing" }));
      }
    } catch (e: any) {
      toast.error(
        e?.response?.data?.message ||
          intl.formatMessage({ id: "app.canvaConnect.backendError" })
      );
    }
  }, [disabled, intl]);

  if (CANVA_COMING_SOON) {
    return (
      <div id="canva" className="d-flex h-100 justify-content-center align-items-center">
        <span
          className={cn(
            "canva-btn canva-btn-theme-default canva-btn-size-s m-0 opacity-4 cursor-not-allowed"
          )}
        >
          <span className="canva-btn-i" />
          {intl.formatMessage({ id: "app.modernImageForm.canvaComingSoon" })}
        </span>
      </div>
    );
  }

  return (
    <>
      <div id="canva" className="d-flex h-100 justify-content-center">
        <span
          onClick={onCanvaButtonClicked}
          className={cn("canva-btn canva-btn-theme-default canva-btn-size-s m-0", {
            "opacity-4": disabled,
            "cursor-not-allowed": disabled,
          })}
        >
          <span className="canva-btn-i" />
          {intl.formatMessage({ id: "app.socialMediaPost.canvaDesing" })}
        </span>
      </div>
      {disabled && (
        <TooltipWembii
          id="canva"
          text={intl.formatMessage({ id: "app.plan.upgrade" })}
        />
      )}
      <CanvaDesignPickerModal
        isOpen={showPicker}
        toggle={() => setShowPicker(false)}
        onExported={handleExported}
      />
    </>
  );
};
